import { useVisualizerStore } from '@/stores/useVisualizerStore';

const GLOSS_LEVELS = [
  { id: 'matte' as const, label: 'Matte', description: 'Soft, non-reflective' },
  { id: 'satin' as const, label: 'Satin', description: 'Subtle sheen' },
  { id: 'high' as const, label: 'High-Gloss', description: 'Mirror-like shine' },
];

export function GlossSelector() {
  const selectedGloss = useVisualizerStore((s) => s.selectedGloss);
  const setGloss = useVisualizerStore((s) => s.setGloss);

  const selectedIndex = GLOSS_LEVELS.findIndex((g) => g.id === selectedGloss);

  return (
    <div className="relative flex rounded-xl bg-slate-100/80 p-0.5 backdrop-blur-sm">
      {/* Sliding highlight pill */}
      <div
        className="absolute top-0.5 bottom-0.5 rounded-[10px] bg-white shadow-md shadow-slate-200/60 transition-all duration-200 ease-out"
        style={{
          left: `calc(${selectedIndex} * (100% / 3) + 2px)`,
          width: 'calc(100% / 3 - 4px)',
        }}
      />
      {/* Sliding blue underline accent */}
      <div
        className="absolute bottom-[3px] h-0.5 rounded-full bg-bss-blue transition-all duration-200 ease-out"
        style={{
          left: `calc(${selectedIndex} * (100% / 3) + 16%)`,
          width: 'calc(100% / 3 - 32%)',
        }}
      />

      {GLOSS_LEVELS.map((gloss) => (
        <button
          key={gloss.id}
          onClick={() => setGloss(gloss.id)}
          className={`relative z-10 flex-1 rounded-lg py-2 text-xs font-bold transition-colors duration-200 ${
            selectedGloss === gloss.id ? 'text-slate-900' : 'text-slate-500 hover:text-slate-700'
          }`}
        >
          {gloss.label}
        </button>
      ))}
    </div>
  );
}
